import { useState, useEffect } from 'react';
import "./testimonial.css"
const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonail] = useState(1);

  // Auto swipe logic
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonail((prev) => (prev === 3 ? 1 : prev + 1));
    }, 6000); // 5000 ms = 5 seconds

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  const dynamicTestimonial = () => {
    if (currentTestimonial === 1) {
      return (
          <div className={currentTestimonial===1?"testimonial__card activetestimonial":"testimonial__card"} key={currentTestimonial}>
            <img src="https://pbs.twimg.com/profile_images/1348830968417804290/fACLFjp8_400x400.jpg" alt="testimonial" loading="lazy" />
     <p>
  We wanted furniture that would truly transform our home, and Morara Homes delivered beyond expectations.  
  The quality, design, and attention to detail were outstanding — every piece feels timeless and unforgettable.  
</p>


<h4> - David Maraga</h4>
<h2><i>Former Chief Justice of Kenya</i></h2>

          </div>
      );
    } else if (currentTestimonial === 2) {
      return (
          <div className={currentTestimonial===2?"testimonial__card activetestimonial":"testimonial__card"} key={currentTestimonial}>
  <img src="https://res.cloudinary.com/dyq5rybiv/image/upload/v1758820658/image11_kzka9f.jpg" alt="testimonial" loading="lazy" />
  <p>
  Morara Homes has been our go-to for quality furniture. Their pieces are stylish, durable, 
  and always become the highlight of our living space. We highly recommend them to anyone 
  who values comfort, elegance, and professionalism.
</p>


  <h4>-John Mwangi</h4>
  <h2><i>Mombasa Cement CE</i>0</h2>
</div>

      );
    } else {
      return (
          <div  className={currentTestimonial===3?"testimonial__card activetestimonial":"testimonial__card"} key={currentTestimonial}>
            <img src="https://res.cloudinary.com/dyq5rybiv/image/upload/v1758820657/image10_av8jnk.jpg" alt="testimonial" loading="lazy" />
    
<p>
  Shopping at Morara Homes was an experience like no other.  
  Their furniture is not only functional but also beautifully crafted — every piece feels like art.  
  My family and I were blown away, and I can’t wait to add more to our home.  
</p>


<h4>- Kimberley Wambui</h4>
<h2><i>Value 8 HR</i></h2>
          </div>
      );
    }
  };

  return (
    <section className="section__container testimonial__container" id="client">
      <p className="section__subheader-testimonials">CLIENT TESTIMONIALS</p>
      <h2 className="section__header-testimonials">100% Approved By Customers</h2>
      <div className="swiper">
        <div className="swiper-wrapper" >
            
        <div className="swiper-slide">
            
            {dynamicTestimonial()}</div></div>
        <div className="pagination">
          <button
            className={currentTestimonial === 1 ? 'active' : ''}
            onClick={() => setCurrentTestimonail(1)}
          >
            1
          </button>
          <button
            className={currentTestimonial === 2 ? 'active' : ''}
            onClick={() => setCurrentTestimonail(2)}
          >
            2
          </button>
          <button
            className={currentTestimonial === 3 ? 'active' : ''}
            onClick={() => setCurrentTestimonail(3)}
          >
            3
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
